import { render, staticRenderFns } from "./AudioSwitch.vue?vue&type=template&id=8b9d329e&"
import script from "./AudioSwitch.vue?vue&type=script&lang=js&"
export * from "./AudioSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports